import React, { useState, useEffect, memo } from "react";
import { MdClose } from "react-icons/md";
import { withFormsy } from "formsy-react";
import { MySelect } from "../../Shared/Forms/Select";
import { Card, CardBody, Input, FormGroup, CardHeader } from "reactstrap";

import "./foodLibrary.css";
const options = [
    { key: "Protein", value: 0 },
    { key: "Carbohydrate", value: 1 },
    { key: "Fat", value: 2 },
    { key: "Saturated-Fat", value: 3 },
    { key: "Unsaturated-Fat", value: 4 },
    { key: "Polyunsaturated-Fat", value: 5 },

    { key: "Monounsaturated-Fat", value: 7 },
    { key: "Trans-Fat", value: 8 },
    { key: "Cholesterol", value: 9 },
    { key: "Sodium", value: 10 },
    { key: "Potassium", value: 11 },
    { key: "Dietary-Fiber", value: 12 },
    { key: "Sugar", value: 13 },
];
const NutrientsCaloriesForm = memo((props) => {
    const { submitted, isView, name, title, disabled, isRequired, submitBottonClick, returnDataFromNutrientValue, hasParams, selectedRow, validateNutrients, editmode } = props;

    const [nutrients, setNutrientOptions] = useState(options);
    const [fat, setFat] = useState({ key: "fat.total", value: null });
    const [carbohydrate, setCarbohydrate] = useState({ key: "carbs.total", value: null });
    const [protein, setProtein] = useState({ key: "protein", value: null });
    const [saturatedFat, setSaturatedFat] = useState({ key: "fat.saturated", value: null });
    const [unSaturatedFat, setUnSaturatedFat] = useState({ key: "fat.unsaturated", value: null });
    const [polyUnSaturatedFat, setPolyUnSaturatedFat] = useState({ key: "fat.polyunsaturated", value: null });
    const [monoUnSaturatedFat, setMonoUnSaturatedFat] = useState({ key: "fat.monounsaturated", value: null });
    const [transFat, setTransFat] = useState({ key: "fat.trans", value: null });
    const [cholesterol, setCholesterol] = useState({ key: "cholesterol", value: null });
    const [sodium, setSodium] = useState({ key: "sodium", value: null });
    const [potassium, setPotassium] = useState({ key: "potassium", value: null });
    const [dietaryFiber, setdietaryFiber] = useState({ key: "dietary_fiber", value: null });
    const [sugar, setSugar] = useState({ key: "sugar", value: null });
    // when change on the nutrients select
    const [showNutrientFields, setShowNutrientFields] = useState(false);
    const [newAddArray, setNewAddArray] = useState([]);

    //validates nutrients values...
    const [fatError, setFatError] = useState(false);
    const [carbohydrateError, setCarbohydrateError] = useState(false);
    const [proteinError, setProteinError] = useState(false);
    const [saturatedFatError, setSaturatedFatError] = useState(false);
    const [unSaturatedFatError, setUnSaturatedFatError] = useState(false);
    const [polyUnSaturatedFatError, setPolyUnSaturatedFatError] = useState(false);
    const [monoUnSaturatedFatError, setMonoUnSaturatedFatError] = useState(false);
    const [transFatError, setTransFatError] = useState(false);
    const [cholesterolError, setCholesterolError] = useState(false);
    const [sodiumError, setSodiumError] = useState(false);
    const [potassiumError, setPotassiumError] = useState(false);
    const [dietaryError, setDietaryError] = useState(false);
    const [sugarError, setSugarError] = useState(false);
    const checkNumberRegex = /^\d*(\.\d+)?$/gm; //  /^[-+]?[0-9]+\.[0-9]+$/

    const removeNutrientsFromSelect = (nutrient) => {
        setNutrientOptions(nutrients.filter((e) => e.key !== nutrient));
    };
    const checkIfInArry = (value, arry) => {
        for (let i = 0; i < arry.length; i++) {
            if (arry[i] === value) {
                return true;
            }
        }
        return false;
    };
    const filterOnEditMode = (nutrient) => {
        let cloneNutrients = JSON.parse(JSON.stringify(nutrients));
        // let filterArr = [];
        for (let i = 0; i < cloneNutrients.length; i++) {
            //if you discover the key at that index remove from the array.at the end return the arry.
            if (cloneNutrients && cloneNutrients[i].key === nutrient) {
                //remove it out from the array...

                return cloneNutrients.filter((e) => e.key !== nutrient);
            }
        }

        // return cloneNutrients;
    };
    const clearNutrientsOnviewClick = () => {
        setNewAddArray([]);
    };
    const addNutrientsForm = (nutrient) => {
        setNewAddArray((newAddArray) => [...newAddArray, nutrient]);
        setShowNutrientFields(true);
    };
    const removeNutrient = (nutrient, key) => {
        if (nutrient === "Fat") {
            setFat({ key: "fat.total", value: null });

            setFatError(false);
        }
        if (nutrient === "Carbohydrate") {
            setCarbohydrate({ key: "carbs.total", value: null });
        }

        if (nutrient === "Protein") {
            setProtein({ key: "protein", value: null });
        }
        if (nutrient === "Saturated-Fat") {
            setSaturatedFat({ key: "fat.saturated", value: null });
        }

        if (nutrient === "Unsaturated-Fat") {
            setUnSaturatedFat({ key: "fat.unsaturated", value: null });
        }

        if (nutrient === "Polyunsaturated-Fat") {
            setPolyUnSaturatedFat({ key: "fat.polyunsaturated", value: null });
        }
        if (nutrient === "Monounsaturated-Fat") {
            setMonoUnSaturatedFat({ key: "fat.monounsaturated", value: null });
        }

        if (nutrient === "Trans-Fat") {
            setTransFat({ key: "fat.trans", value: null });
        }

        if (nutrient === "Cholesterol") {
            setCholesterol({ key: "cholesterol", value: null });
        }
        if (nutrient === "Sodium") {
            setSodium({ key: "sodium", value: null });
        }
        if (nutrient === "Potassium") {
            setPotassium({ key: "potassium", value: null });
        }
        if (nutrient === "Dietary-Fiber") {
            setdietaryFiber({ key: "dietary_fiber", value: null });
        }
        if (nutrient === "Sugar") {
            setSugar({ key: "sugar", value: null });
        }
        //remove from the new add array
        setNewAddArray(newAddArray.filter((e) => e !== nutrient));
        //add it back to setNutrients fields.
        setNutrientOptions([...nutrients, { key: nutrient, value: key }]);
    };
    const resetButtonClick = () => {
        //clear all the nutrient values.
        resetForm();
    };
    const resetForm = () => {
        setCarbohydrate({ key: "carbs.total", value: "" });
        setFat({ key: "fat.total", value: "" });
        setProtein({ key: "protein", value: "" });
        setSaturatedFat({ key: "fat.saturated", value: "" });
        setUnSaturatedFat({ key: "fat.unsaturated", value: "" });
        setPolyUnSaturatedFat({ key: "fat.polyunsaturated", value: "" });
        setMonoUnSaturatedFat({ key: "fat.monounsaturated", value: "" });
        setTransFat({ key: "fat.trans", value: "" });
        setCholesterol({ key: "cholesterol", value: "" });
        setSodium({ key: "sodium", value: "" });
        setPotassium({ key: "potassium", value: "" });
        setdietaryFiber({ key: "dietary_fiber", value: "" });
        setSugar({ key: "sugar", value: "" });
    };

    const onChange = (e) => {
        try {
            if (editmode) {
                //check first if it is in the array.
                let isInArry = checkIfInArry(e.key, newAddArray);
                if (!isInArry) {
                    addNutrientsForm(e.key);
                    removeNutrientsFromSelect(e.key);
                }
            } else {
                addNutrientsForm(e.key);
                removeNutrientsFromSelect(e.key);
            }
        } catch (e) {
            console.error(e);
        }
    };
    const handleNutrientInput = (e) => {
        try {
            if (e.target.id === "fat.total") {
                if (e.target.value.match(checkNumberRegex)) {
                    setFat({ key: e.target.id, value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setFatError(false);
                } else {
                    setFat({ key: e.target.id, value: e.target.value });
                    validateNutrients(true);
                    setFatError(true);
                }
            }
            if (e.target.id === "carbohydrate") {
                if (e.target.value.match(checkNumberRegex)) {
                    setCarbohydrate({ key: "carbs.total", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setCarbohydrateError(false);
                } else {
                    setCarbohydrate({ key: "carbs.total", value: e.target.value });
                    validateNutrients(true);
                    setCarbohydrateError(true);
                }
            }
            if (e.target.id === "protein") {
                if (e.target.value.match(checkNumberRegex)) {
                    setProtein({ key: e.target.id, value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setProteinError(false);
                } else {
                    setProtein({ key: e.target.id, value: e.target.value });
                    validateNutrients(true);
                    setProteinError(true);
                }
            }
            if (e.target.id === "Saturated-Fat") {
                if (e.target.value.match(checkNumberRegex)) {
                    setSaturatedFat({ key: "fat.saturated", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setSaturatedFatError(false);
                } else {
                    setSaturatedFat({ key: "fat.saturated", value: e.target.value });
                    validateNutrients(true);
                    setSaturatedFatError(true);
                }
            }
            if (e.target.id === "Unsaturated-Fat") {
                if (e.target.value.match(checkNumberRegex)) {
                    setUnSaturatedFat({ key: "fat.unsaturated", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setUnSaturatedFatError(false);
                } else {
                    setUnSaturatedFat({ key: "fat.unsaturated", value: e.target.value });
                    validateNutrients(true);
                    setUnSaturatedFatError(true);
                }
            }
            if (e.target.id === "Polyunsaturated-Fat") {
                if (e.target.value.match(checkNumberRegex)) {
                    setPolyUnSaturatedFat({ key: "fat.polyunsaturated", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setPolyUnSaturatedFatError(false);
                } else {
                    setPolyUnSaturatedFat({ key: "fat.polyunsaturated", value: e.target.value });
                    validateNutrients(true);
                    setPolyUnSaturatedFatError(true);
                }
            }
            if (e.target.id === "Monounsaturated-Fat") {
                if (e.target.value.match(checkNumberRegex)) {
                    setMonoUnSaturatedFat({ key: "fat.monounsaturated", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setMonoUnSaturatedFatError(false);
                } else {
                    setMonoUnSaturatedFat({ key: "fat.monounsaturated", value: e.target.value });
                    validateNutrients(true);
                    setMonoUnSaturatedFatError(true);
                }
            }
            if (e.target.id === "Trans-Fat") {
                if (e.target.value.match(checkNumberRegex)) {
                    setTransFat({ key: "fat.trans", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setTransFatError(false);
                } else {
                    setTransFat({ key: "fat.trans", value: e.target.value });
                    validateNutrients(true);
                    setTransFatError(true);
                }
            }

            if (e.target.id === "Cholesterol") {
                if (e.target.value.match(checkNumberRegex)) {
                    setCholesterol({ key: "cholesterol", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setCholesterolError(false);
                } else {
                    setCholesterol({ key: "cholesterol", value: e.target.value });
                    validateNutrients(true);
                    setCholesterolError(true);
                }
            }

            if (e.target.id === "Sodium") {
                if (e.target.value.match(checkNumberRegex)) {
                    setSodium({ key: "sodium", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setSodiumError(false);
                } else {
                    setSodium({ key: "sodium", value: e.target.value });
                    validateNutrients(true);
                    setSodiumError(true);
                }
            }
            if (e.target.id === "Potassium") {
                if (e.target.value.match(checkNumberRegex)) {
                    setPotassium({ key: "potassium", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setPotassiumError(false);
                } else {
                    setPotassium({ key: "potassium", value: e.target.value });
                    validateNutrients(true);
                    setPotassiumError(true);
                }
            }
            if (e.target.id === "Dietary-Fiber") {
                if (e.target.value.match(checkNumberRegex)) {
                    setdietaryFiber({ key: "dietary_fiber", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setDietaryError(false);
                } else {
                    setdietaryFiber({ key: "dietary_fiber", value: e.target.value });
                    validateNutrients(true);
                    setDietaryError(true);
                }
            }
            if (e.target.id === "Sugar") {
                if (e.target.value.match(checkNumberRegex)) {
                    setSugar({ key: "sugar", value: e.target.value ? parseFloat(e.target.value) : null });
                    validateNutrients(false);
                    setSugarError(false);
                } else {
                    setSugar({ key: "sugar", value: e.target.value });
                    validateNutrients(true);
                    setSugarError(true);
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (submitted) {
            resetForm();
        }
    }, [submitted]);

    useEffect(() => {
        clearNutrientsOnviewClick();
        if (hasParams && selectedRow && isView) {
            selectedRow.nutrients.map((key) => {
                if (key.key === "fat.total") {
                    addNutrientsForm("Fat");

                    setFat({ key: "fat.total", value: key.value });
                }
                if (key.key === "protein") {
                    addNutrientsForm("Protein");
                    setProtein({ key: "protein", value: key.value });
                }
                if (key.key === "carbs.total") {
                    addNutrientsForm("Carbohydrate");
                    setCarbohydrate({ key: "carbs.total", value: key.value });
                }
                if (key.key === "fat.saturated") {
                    addNutrientsForm("Saturated-Fat");
                    setSaturatedFat({ key: "fat.saturated", value: key.value });
                }
                if (key.key === "fat.unsaturated") {
                    addNutrientsForm("Unsaturated-Fat");
                    setUnSaturatedFat({ key: "fat.unsaturated", value: key.value });
                }
                if (key.key === "fat.polyunsaturated") {
                    addNutrientsForm("Polyunsaturated-Fat");
                    setPolyUnSaturatedFat({ key: "fat.polyunsaturated", value: key.value });
                }
                if (key.key === "fat.monounsaturated") {
                    addNutrientsForm("Monounsaturated-Fat");
                    setMonoUnSaturatedFat({ key: "fat.monounsaturated", value: key.value });
                }
                if (key.key === "fat.trans") {
                    addNutrientsForm("Trans-Fat");
                    setTransFat({ key: "fat.trans", value: key.value });
                }

                if (key.key === "cholesterol") {
                    addNutrientsForm("Cholesterol");
                    setCholesterol({ key: "cholesterol", value: key.value });
                }
                if (key.key === "sodium") {
                    addNutrientsForm("Sodium");
                    setSodium({ key: "sodium", value: key.value });
                }
                if (key.key === "potassium") {
                    addNutrientsForm("Potassium");
                    setPotassium({ key: "potassium", value: key.value });
                }
                if (key.key === "dietary_fiber") {
                    addNutrientsForm("Dietary-Fiber");
                    setdietaryFiber({ key: "dietary_fiber", value: key.value });
                }
                if (key.key === "sugar") {
                    addNutrientsForm("Sugar");
                    setSugar({ key: "sugar", value: key.value });
                }
                return null;
            });
        }
        if (!hasParams && !selectedRow && !isView) {
            resetButtonClick();
        }
    }, [hasParams, selectedRow, isView]);

    useEffect(() => {
        if (hasParams && selectedRow && editmode) {
            selectedRow.nutrients.map((key, index) => {
                if (key.key === "fat.total") {
                    addNutrientsForm("Fat");
                    setFat({ key: "fat.total", value: key.value });
                    //  removeNutrientsFromSelect("Fat");
                    setNutrientOptions(filterOnEditMode("Fat"));
                }
                if (key.key === "protein") {
                    addNutrientsForm("Protein");
                    setProtein({ key: "protein", value: key.value });
                    //removeNutrientsFromSelect("Protein");
                    // filterOnEditMode("Protein");
                    setNutrientOptions(filterOnEditMode("Protein"));
                }
                if (key.key === "carbs.total") {
                    addNutrientsForm("Carbohydrate");
                    setCarbohydrate({ key: "carbs.total", value: key.value });
                    //  removeNutrientsFromSelect("Carbohydrate");
                    //filterOnEditMode("Carbohydrate");
                    setNutrientOptions(filterOnEditMode("Carbohydrate"));
                }
                if (key.key === "fat.saturated") {
                    addNutrientsForm("Saturated-Fat");
                    setSaturatedFat({ key: "fat.saturated", value: key.value });
                    //removeNutrientsFromSelect("Saturated-Fat");
                    // filterOnEditMode("Saturated-Fat");
                    setNutrientOptions(filterOnEditMode("Saturated-Fat"));
                }
                if (key.key === "fat.unsaturated") {
                    addNutrientsForm("Unsaturated-Fat");
                    setUnSaturatedFat({ key: "fat.unsaturated", value: key.value });
                    //removeNutrientsFromSelect("Unsaturated-Fat");
                    //  filterOnEditMode("Unsaturated-Fat");
                    setNutrientOptions(filterOnEditMode("Unsaturated-Fat"));
                }
                if (key.key === "fat.polyunsaturated") {
                    addNutrientsForm("Polyunsaturated-Fat");
                    setPolyUnSaturatedFat({ key: "fat.polyunsaturated", value: key.value });
                    //removeNutrientsFromSelect("Polyunsaturated-Fat");
                    // filterOnEditMode("Polyunsaturated-Fat");
                    setNutrientOptions(filterOnEditMode("Polyunsaturated-Fat"));
                }
                if (key.key === "fat.monounsaturated") {
                    addNutrientsForm("Monounsaturated-Fat");
                    setMonoUnSaturatedFat({ key: "fat.monounsaturated", value: key.value });
                    //removeNutrientsFromSelect("Monounsaturated-Fat");
                    //filterOnEditMode("Monounsaturated-Fat");
                    setNutrientOptions(filterOnEditMode("Monounsaturated-Fat"));
                }
                if (key.key === "fat.trans") {
                    addNutrientsForm("Trans-Fat");
                    setTransFat({ key: "fat.trans", value: key.value });
                    // removeNutrientsFromSelect("Trans-Fat");

                    //filterOnEditMode("Trans-Fat");
                    setNutrientOptions(filterOnEditMode("Trans-Fat"));
                }

                if (key.key === "cholesterol") {
                    addNutrientsForm("Cholesterol");
                    setCholesterol({ key: "cholesterol", value: key.value });
                    //removeNutrientsFromSelect("Cholesterol");
                    //filterOnEditMode("Cholesterol");
                    setNutrientOptions(filterOnEditMode("Cholesterol"));
                }
                if (key.key === "sodium") {
                    addNutrientsForm("Sodium");
                    setSodium({ key: "sodium", value: key.value });
                    // removeNutrientsFromSelect("Sodium");
                    // filterOnEditMode("Sodium");
                    setNutrientOptions(filterOnEditMode("Sodium"));
                }
                if (key.key === "potassium") {
                    addNutrientsForm("Potassium");
                    setPotassium({ key: "potassium", value: key.value });
                    //removeNutrientsFromSelect("Potassium");
                    // filterOnEditMode("Potassium");
                    setNutrientOptions(filterOnEditMode("Potassium"));
                }
                if (key.key === "dietary_fiber") {
                    addNutrientsForm("Dietary-Fiber");
                    setdietaryFiber({ key: "dietary_fiber", value: key.value });
                    // removeNutrientsFromSelect("Dietary-Fiber");
                    // filterOnEditMode("Dietary-Fiber");
                    setNutrientOptions(filterOnEditMode("Dietary-Fiber"));
                }
                if (key.key === "sugar") {
                    addNutrientsForm("Sugar");
                    setSugar({ key: "sugar", value: key.value });
                    // removeNutrientsFromSelect("Sugar");
                    // filterOnEditMode("Sugar");
                    setNutrientOptions(filterOnEditMode("Sugar"));
                }
                // return null;
            });
        }
        if (!hasParams && !selectedRow && !isView && !editmode) {
            resetButtonClick();
        }
    }, [hasParams, selectedRow, editmode]);

    useEffect(() => {
        if (submitBottonClick) {
            let nutrientsValue = [];
            if (fat.value !== "" && fat.value !== null) {
                nutrientsValue.push(fat);
            }
            if (carbohydrate.value !== "" && carbohydrate.value !== null) {
                nutrientsValue.push(carbohydrate);
            }
            if (protein.value !== "" && protein.value !== null) {
                nutrientsValue.push(protein);
            }
            if (saturatedFat.value !== "" && saturatedFat.value !== null) {
                nutrientsValue.push(saturatedFat);
            }
            if (unSaturatedFat.value !== "" && unSaturatedFat.value !== null) {
                nutrientsValue.push(unSaturatedFat);
            }
            if (polyUnSaturatedFat.value !== "" && polyUnSaturatedFat.value !== null) {
                nutrientsValue.push(polyUnSaturatedFat);
            }
            if (monoUnSaturatedFat.value !== "" && monoUnSaturatedFat.value !== null) {
                nutrientsValue.push(monoUnSaturatedFat);
            }
            if (transFat.value !== "" && transFat.value !== null) {
                nutrientsValue.push(transFat);
            }
            if (cholesterol.value !== "" && cholesterol.value !== null) {
                nutrientsValue.push(cholesterol);
            }
            if (sodium.value !== "" && sodium.value !== null) {
                nutrientsValue.push(sodium);
            }
            if (potassium.value !== "" && potassium.value !== null) {
                nutrientsValue.push(potassium);
            }
            if (dietaryFiber.value !== "" && dietaryFiber.value !== null) {
                nutrientsValue.push(dietaryFiber);
            }
            if (sugar.value !== "" && sugar.value !== null) {
                nutrientsValue.push(sugar);
            }
            returnDataFromNutrientValue(nutrientsValue);
        }
    }, [submitBottonClick]);

    return (
        <div>
            <FormGroup>
                <MySelect isMulti={false} name={name} isClearable={false} onChange={onChange} title={title} options={nutrients} valueKey="value" disabled={disabled} labelKey="key" isRequired={isRequired} defaultOptions={null} />
                {showNutrientFields &&
                    newAddArray.map((nutrientName, index) =>
                        nutrientName === "Fat" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    {/* <Row> */}

                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="fat" id="fat.total" value={fat.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: fatError ? "red" : null }} />
                                    {/* </Row> */}
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Carbohydrate" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="carbohydrate" id="carbohydrate" value={carbohydrate.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: carbohydrateError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Protein" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="protein" id="protein" value={protein.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: proteinError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Saturated-Fat" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Saturated-Fat" id="Saturated-Fat" value={saturatedFat.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: saturatedFatError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Unsaturated-Fat" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "7rem" }}>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Unsaturated-Fat" id="Unsaturated-Fat" value={unSaturatedFat.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: unSaturatedFatError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Polyunsaturated-Fat" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "7rem" }}>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input
                                        type="text"
                                        name="Polyunsaturated-Fat"
                                        id="Polyunsaturated-Fat"
                                        value={polyUnSaturatedFat.value}
                                        onChange={handleNutrientInput}
                                        disabled={hasParams && selectedRow && isView ? true : false}
                                        size="40"
                                        style={{ borderColor: polyUnSaturatedFatError ? "red" : null }}
                                    />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Monounsaturated-Fat" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "6rem" }}>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input
                                        type="text"
                                        name="Monounsaturated-Fat"
                                        id="Monounsaturated-Fat"
                                        value={monoUnSaturatedFat.value}
                                        onChange={handleNutrientInput}
                                        disabled={hasParams && selectedRow && isView ? true : false}
                                        size="40"
                                        style={{ borderColor: monoUnSaturatedFatError ? "red" : null }}
                                    />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Trans-Fat" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "11rem" }}>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Trans-Fat" id="Trans-Fat" value={transFat.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: transFatError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Cholesterol" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "9rem" }}>{nutrientName} (milligrams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Cholesterol" id="Cholesterol" value={cholesterol.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: cholesterolError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Sodium" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "10rem" }}>{nutrientName} (milligrams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Sodium" id="Sodium" value={sodium.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: sodiumError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Potassium" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "9rem" }}>{nutrientName} (milligrams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Potassium" id="Potassium" value={potassium.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: potassiumError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Dietary-Fiber" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "8rem" }}>{nutrientName} (milligrams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Dietary-Fiber" id="Dietary-Fiber" value={dietaryFiber.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: dietaryError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : nutrientName === "Sugar" ? (
                            <Card className="mb-4" key={index}>
                                <CardHeader className="cancelflexcontainer spacebetween">
                                    <span style={{ marginRight: "12rem" }}>{nutrientName} (grams)</span>
                                    {hasParams && selectedRow && isView ? null : <MdClose className="remove-icon" onClick={() => removeNutrient(nutrientName, index)} style={{ cursor: "pointer", color: "red" }} />}
                                </CardHeader>
                                <CardBody>
                                    <span style={{ color: "blue", fontSize: "11px" }}>Enter Calorie Value (numbers only)</span>
                                    <Input type="text" name="Sugar" id="Sugar" value={sugar.value} onChange={handleNutrientInput} disabled={hasParams && selectedRow && isView ? true : false} size="40" style={{ borderColor: sugarError ? "red" : null }} />
                                </CardBody>
                            </Card>
                        ) : null
                    )}
            </FormGroup>
        </div>
    );
});
//
export default withFormsy(NutrientsCaloriesForm);
